export { RoutePaths, ApplicationRoutes, ProfileNestedRoutes } from './appRoutes';

export const APP_NAME = 'prompthub';

export const RULES_NEW_URL = 'https://lpc-ext.s3.yandex.net/ai-platform/legal/new_rules.pdf';
export const RULES_COMPETE_URL = 'https://lpc-ext.s3.yandex.net/ai-platform/legal/compete_rules.pdf';

export const CONDITIONS_URL = 'https://yandex.ru/legal/prompthub/ru/';
export const PRIVACY_POLICY_URL = 'https://yandex.ru/legal/confidential/ru/';
export const TELEGRAM_CHANNEL_URL = 'https://t.me/prompthub_yndx';

export const PHANTOMAS_ACHIEVEMENT_IMAGE =
    'https://avatars.mds.yandex.net/get-ai_platform/14794369/achievement_fantomas_1765466529677/optimize';
export const SEARCH_PARAMS = {
    ACHIEVEMENT: 'achievement',
};
